import { personas, type RankStatus } from "@/mocks/blackMaterial";

const statusPill: Record<RankStatus, string> = {
  塌房: "bg-primary-100 text-primary-700",
  翻车: "bg-accent-100 text-accent-800",
  争议: "bg-secondary-200/70 text-foreground-600",
};

export default function ProfileSection() {
  return (
    <section id="profiles" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-3">
          <span className="text-xs font-semibold tracking-[0.18em] text-secondary-500">黑料主角 · 一页纸档案</span>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">争议人物档案夹</h2>
          <p className="max-w-2xl text-sm leading-7 text-foreground-500">
            把每个人的争议脉络收进一页：怎么上榜、卡在哪个节点、正在被追什么。看完一份，基本就懂一个人是怎么凉的。
          </p>
        </div>

        <div className="mt-8 grid gap-4 lg:grid-cols-3">
          {personas.map((p) => (
            <div
              key={p.name}
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100/50 p-5 transition-colors hover:border-background-300"
            >
              <div className="flex items-center gap-3">
                <span className={`inline-flex items-center justify-center rounded-full px-2.5 py-1 text-[11px] font-semibold ${statusPill[p.status]}`}>
                  {p.status}
                </span>
                <span className="text-xs text-foreground-400">{p.field}</span>
              </div>
              <h3 className="mt-3 text-lg font-bold text-foreground-950 group-hover:text-primary-700">{p.name}</h3>
              <p className="mt-1.5 text-sm leading-6 text-foreground-600">{p.summary}</p>

              <ul className="mt-4 space-y-2 border-t border-dashed border-background-200 pt-4">
                {p.points.map((pt) => (
                  <li key={pt} className="flex items-start gap-2 text-xs leading-5 text-foreground-500">
                    <i className="ri-checkbox-blank-circle-fill mt-1 text-[6px] text-accent-500" />
                    <span>{pt}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-auto flex flex-wrap gap-1.5 pt-4">
                {p.tags.map((t) => (
                  <span key={t} className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-1 text-[11px] text-foreground-600">
                    # {t}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}